// extracted by mini-css-extract-plugin
export default {"root":"_3h2Sb","message":"_2aPrr","button":"SEB__"};